const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
async function listBlockedInventories(){
    try{
        let response = await fetch(`${apiBaseUrl}/inventoryManagement/listBlockedInvs`,{
            method:"GET",
            credentials:"include"
        })
        let responseJson = await response.json();
        if(responseJson.success){
            return responseJson.inventoriesBlocked
        }else{
            throw new Error(responseJson.message)
        }
    }catch(err){
        throw new Error(err.message)
    }
}
export default listBlockedInventories